module.exports = __webpack_public_path__ + "static/portfolio_gallery_30-a4f5d559014294341e5ca00deb677d6a.jpg";